module.exports = __webpack_public_path__ + "img/orange-ppc212.c30a4d41.jpg";